import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
// ==========引用web 的js=============
import { Index } from "./pages";


//===========引用樣式==============
import "./styles/App.css";

function App() {
  return <Router>
    <Switch>

      {/* ===============首頁================= */}
      <Router exact path="/"><Index /></Router>

    </Switch>
  </Router>
}
export default App;
